module.exports = __webpack_public_path__ + "bfdf37423b9b0322abae821a6e2984b9.svg";